<template>
    <div v-if="isPc" class="container">
        <div class="content" v-if="serviceData">
            <span class="title">{{ serviceData.title }}</span>
            <span class="description">{{ serviceData.text }}</span>
            <div class="buttons">
                <div class="button phone-consultation" @click="btnClick('phone')">
                    <img class="phone-icon" :src="serviceData.phoneIcon" alt="Phone" loading="lazy" />

                    <span>{{ serviceData.phoneText }}</span>
                    <span class="phone-number">{{ serviceData.phoneNumber }}</span>
                </div>
                <el-popover placement="right" width="170" trigger="hover" popper-class="my-custom-popover">
                    <div slot="reference" class="button add-wechat" @click="btnClick('wechat')">
                        <img class="wechat-icon" :src="serviceData.wechatIcon" alt="Wechat Icon" loading="lazy" />
                        <span>{{ serviceData.wechatText }}</span>
                    </div>
                    <!-- 二维码图片和提示文字 -->
                    <div class="qrcode-content">
                        <img :src="serviceData.qrCodeImage" alt="企业微信二维码" class="qrcode-image" loading="lazy" />
                        <p class="qrcode-text">{{ serviceData.qrText }}</p>
                    </div>
                </el-popover>
            </div>
        </div>
        <img class="background-image" :src="serviceData.rightImg" alt="Background Image" />
    </div>
    <div v-else class="mob-container">
        <img class="mob-background-image" :src="serviceData.img_mob" alt="Background Image" ></img>
        <div class="mob-content">
            <div class="mob-title">
                <span class="mob-title-text">{{ serviceData.title_first }}</span>
                <span class="mob-title-text">{{ serviceData.title_second }}</span>
            </div>
            <div class="mob-description">{{ serviceData.text }}</div>
            <div class="mob-buttons">
                <div class="mob-button mob-phone-button" :style="{ marginRight: '8px' }" @click="callPhone">
                    <img class="mob-phone-icon" :src="serviceData.phoneIcon" alt="Phone" loading="lazy" />
                    <span class="mob-phone-text">{{ serviceData.phoneText }}</span>
                    <span class="mob-phone-number">{{ serviceData.phoneNumber }}</span>
                </div>
                <div class="mob-button mob-wechat-button" @click="showQRCode">
                    <img class="mob-wechat-icon" :src="serviceData.wechatIcon" alt="Wechat Icon" loading="lazy" />
                    <span class="mob-wechat-text">{{ serviceData.wechatText }}</span>
                </div>
            </div>
        </div>
        
        <!-- 微信二维码弹窗 -->
        <div v-if="showQRCodePopup" class="qr-popup-overlay" @click="closeQRCode">
            <div class="qr-popup-content" @click.stop>
                <div class="img-container">
                    <img @click="saveQRCode" :src="serviceData.qrMobImage" alt="企业微信二维码" class="qr-popup-image" />
                </div>
                <p class="qr-popup-text">{{ serviceData.qrMobText }}</p>
                <el-button :circle="true" class="qr-close-button" @click="closeQRCode" icon="el-icon-close"></el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { dataReport } from '../../../../../../utils/report';
export default {
    props: {
        isPc: {
            type: Boolean,
            default: true
        },
        serviceInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            showQRCodePopup: false,
        };
    },
    methods:{
        handleExposure() {
            if(this.isPc){
                dataReport(
                {
                    hottag: `FQL_HOME_WEB_SERVICE_EXPOSURE`,
                    eventPosName: `分期乐web首页服务曝光`,
                    eventType: 1, //曝光
                },
                { serviceInfo: this.serviceData }
            );
            }
            else{
                dataReport(
                {
                    hottag: `FQL_HOME_MOB_SERVICE_EXPOSURE`,
                    eventPosName: `分期乐移动端首页服务曝光`,
                    eventType: 1, //曝光
                },
                { serviceInfo: this.serviceData }
            );
            }
        },
        btnClick(type) {
            dataReport(
                {
                    hottag: `FQL_HOME_WEB_SERVICE_BTN_CLICK`,
                    eventPosName: `分期乐web首页服务按钮点击`,
                    eventType: 2, //点击
                },
                { type }
            );
        },
        callPhone() {
            dataReport(
                {
                    hottag: `FQL_HOME_MOB_SERVICE_PHONE_CLICK`,
                    eventPosName: `分期乐mob首页服务电话点击`,
                    eventType: 2, //点击
                }
            );
            window.location.href = `tel:${this.serviceData.phoneNumber}`;
        },
        showQRCode() {
            dataReport(
                {
                    hottag: `FQL_HOME_MOB_SERVICE_QRCODE_CLICK`,
                    eventPosName: `分期乐mob首页服务二维码点击`,
                    eventType: 2, //点击
                }
            );
            this.showQRCodePopup = true;
        },
        closeQRCode() {
            this.showQRCodePopup = false;
        },
        saveQRCode() {
            // 使用 fetch 获取图片数据，然后创建下载链接
            fetch(this.serviceData.qrCodeImage)
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = 'qrcode.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch(err => {
                    console.error('下载二维码失败:', err);
                    // 如果下载失败，则使用原始方法
                    const link = document.createElement('a');
                    link.href = this.serviceData.qrCodeImage;
                    link.download = 'qrcode.png';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        }
    },
    computed: {
        serviceData() {
            // 获取原始数据
            const originalData = this.serviceInfo?.[1]?.[0] || {};
            // 仅提取所需字段（按需调整字段列表）
            return {
                title: originalData.title,
                text: originalData.text,
                phoneIcon: originalData.phone_icon,
                phoneText: originalData.phone_text1,
                phoneNumber: originalData.phone_text2,
                wechatIcon: originalData.wechat_icon,
                wechatText: originalData.wechat_text,
                rightImg: originalData.img,
                qrCodeImage: originalData.qr_img,
                qrText: originalData.qr_text,
                img_mob: originalData.img_mob,
                title_first: originalData.mob_first,
                title_second: originalData.mob_second,
                qrMobImage: originalData.qr_mob_image,
                qrMobText: originalData.qr_mob_text
            }
        }
    },
    watch: {
        serviceInfo: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleExposure();
                }
            },
            deep: true
        }
    }
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: row;
    height: 330px;
    justify-content: flex-start;
    align-items: flex-start;
    background-color: rgb(255, 255, 255);
}

.content {
    margin-top: 40px;
    margin-left: 40px;
    margin-right: 36px;
}

.title {
    color: rgb(77, 131, 255);
    font-family: 'PingFang SC';
    font-size: 24px;
    font-weight: 500;
}

.description {
    color: rgba(65, 65, 65, 0.80);
    font-family: 'PingFang SC';
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 77px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 20px;
    line-height: 24px;
}

.buttons {
    display: flex;
}

.button {
    display: flex;
    padding: 10px;
    background-color: rgb(255, 255, 255);
    border: 0.5px solid #C2C2C2;
    border-radius: 0;
    width: 221px;
    height: 54px;
    margin-right: 10px;
    align-items: center;
}

.phone-number {
    color: rgb(47, 47, 47);
    font-family: 'Alibaba PuHuiTi 3.0';
    font-size: 25px;
    font-weight: 800;
    margin-left: 8px;
}

.phone-consultation {
    padding-left: 31px;
}

.add-wechat {
    padding-left: 49px;
}

.add-wechat img {
    margin-right: 8px;
}

.background-image {
    width: 539px;
    height: 100%;
}

.phone-icon {
    width: 16px;
    height: 16px;
    margin-right: 3px;
}

.wechat-icon {
    width: 19px;
    height: 19px;
}

.qrcode-content {
    align-items: center;
    text-align: center;
}

.qrcode-text {
    color: rgb(65, 65, 65);
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
}

.my-custom-popover {
    display: flex;
    justify-content: center;
}

.mob-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    width: 91%;
    border: 1px solid #FFF;
    border-radius: 4px;
    padding-bottom: 30px;
}

.mob-background-image {
    width: 91vw;
    height: auto;
}

.mob-content{
    display: flex;
    flex-direction: column;
    padding-top:20px;
    padding-left: 20px;
    padding-right: 20px;
}

.mob-title{
    display: flex;
    flex-direction: column;
    margin-bottom: 14px;
}

.mob-title-text{
    color: #3371FF;
    font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
}

.mob-description{
    width: 315px;
    color: rgba(30, 37, 51, 0.60);
    font-family: "PingFang SC";
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 20px;
}

.mob-buttons{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.mob-button{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: 0.8px solid #C2C2C2;
    border-radius: 4px;
    width: 153.5px;
    height: 44px;
}

.mob-phone-icon{
    width: 12px;
    height: 12px;
    margin-right: 1px;
}

.mob-phone-text{
    color: #000;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
    margin-right: 1px;
}

.mob-phone-number{
    color: #000;
    font-family: "PingFang SC";
    font-size: 17.6px;
    font-weight: 800;
}

.mob-wechat-icon{
    width: 12px;
    height: 12px;
    margin-right: 4px;
}

.mob-wechat-text{
    color: #000;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
}

/* 二维码弹窗样式 */
.qr-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.qr-popup-content {
    background-color: white;
    border-radius: 8px;
    text-align: center;
    max-width: 300px;
    width: 295px;
}

.img-container {
    padding-top: 24px;
    padding-bottom: 24px;
    border-bottom: 0.5px solid #EDEDEE;
}

.qr-popup-image {
    width: 185px;
    height: 185px;
}

.qr-popup-text {
    color: #fff;
    font-family: "PingFang SC";
    font-size: 16px;
    font-weight: 500;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: #4A82FF;
    border-radius: 0px 0px 8px 8px;
}

.qr-save-button {
    width: 100%;
    padding: 12px;
    margin-bottom: 30px;
    border: none;
    border-radius: 6px;
    font-family: "PingFang SC";
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #3371FF;
    color: white;
}

.qr-save-button {
    background-color: #3371FF;
    color: white;
}

.qr-close-button {
    position: absolute;
    bottom: 20%;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.3;
    border: none;
    font-size: 24px;
    color: #666;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
}

.qr-close-button:hover {
    background-color: #e9e9e9;
    transform: translateX(-50%) scale(1.05);
}

.qr-mob-image{
    width: 185px;
    height: 185px;
}
</style>